module.exports = __webpack_public_path__ + "static/media/buttonProduct_when.b0d016f4.png";